import { type InferResponseType, unwrap } from "@nexxt/api-client";
import type { ListProductsInput } from "@nexxt/contracts/catalog";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the products (pattern.md §10): the list by cursor, and a product with its SKUs and linesheets.

type ListPage = InferResponseType<typeof api.catalog.products.$get, 200>;
export type ProductListItem = ListPage["items"][number];
export type Product = InferResponseType<(typeof api.catalog.products)[":productId"]["$get"], 200>;

export type ProductFilters = Pick<ListProductsInput, "status" | "q" | "brand">;

const keys = { all: ["products"] as const };

export const productQueries = {
  ...keys,

  list: ({ status, q, brand }: ProductFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "list", { status, q, brand }],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          api.catalog.products.$get(
            {
              query: {
                ...(status && { status }),
                ...(q && { q }),
                ...(brand && { brand }),
                ...(pageParam && { cursor: pageParam }),
                limit: "50",
              },
            },
            { init: { signal } },
          ),
        ),
      initialPageParam: "",
      getNextPageParam: (last) => last.nextCursor ?? undefined,
    }),

  detail: (productId: string) =>
    queryOptions({
      queryKey: [...keys.all, "detail", productId],
      queryFn: ({ signal }) =>
        unwrap(api.catalog.products[":productId"].$get({ param: { productId } }, { init: { signal } })),
    }),
};
